<template>
  
  <div class="card pt-15">
    <div v-show="cadastro" class="card-body">
      <h4 class="card-title">Cadastro de Fornecedores</h4>
      <button class="btn btn-info" @click="exibirLista" >Exibir Fornecedores</button>
      <form class="m-t-40" @keydown.enter.prevent v-on:submit.prevent="update">
        <div class="row col-md-12 col-12 pt-10">
          <div class="form-group col-md-4">
          <label>Razão Social</label>
          <input type="text" class="form-control" required placeholder="Obrigatório"  v-model="fornecedor.razao_nome">
        </div>
        <div class="form-group col-md-4">
          <label>CNPJ</label>
          <input v-model="fornecedor.cnpj_cpf" type="text" required class="form-control" placeholder="Obrigatório" v-mask="{mask: ['999.999.999-99', '99.999.999/9999-99' ]}"/>
        </div>
        <div class="form-group col-md-4">
          <label>Inscrição Estadual</label>
          <input type="text" class="form-control"  placeholder="Opcional" v-model="fornecedor.ie_rg">
        </div>
        <div class="form-group col-md-4">
          <label>CEP</label>
          <input type="text" class="form-control" v-mask="['#####-###']" masked="false" placeholder="Opcional" @blur="carregarcep" v-model="fornecedor.cep">
        </div>
        <div class="form-group col-md-4">
          <label>Rua</label>
          <input type="text" class="form-control"  placeholder="Opcional" v-model="fornecedor.endereco">
        </div>
        <div class="form-group col-md-4"> 
          <label>Número</label>
          <input type="text" class="form-control"  placeholder="Opcional" v-model="fornecedor.numero">
        </div>
        <div class="form-group col-md-4">
          <label>Bairro</label>
          <input type="text" class="form-control"  placeholder="Opcional" v-model="fornecedor.bairro">
        </div>  
        <div class="form-group col-md-4">
          <label>Cidade</label>
          <input type="text" class="form-control"  placeholder="Opcional" v-model="fornecedor.cidade">
          <input type="hidden" class="form-control"  v-model="fornecedor.codigo_cidade">
        </div>
        <div class="form-group col-md-4">
          <label>Estado</label>
          <select type="text" class="form-control"  placeholder="Opcional" v-model="fornecedor.estado">
            <option value="0">Acre</option>
            <option value="1">Alagoas</option>
            <option value="2">Amazonas</option>
            <option value="3">Amapá</option>
            <option value="4">Bahia</option>
            <option value="5">Ceará</option>
            <option value="6">Distrito Federal</option>
            <option value="7">Espirito Santo</option>
            <option value="8">Goiás</option>
            <option value="9">Maranhão</option>
            <option value="10">Minas Gerais</option>
            <option value="11">Mato Grosso do Sul</option>
            <option value="12">Mato Grosso</option>
            <option value="13">Pará</option>
            <option value="14">Paraíba</option>
            <option value="15">Pernambuco</option>
            <option value="16">Piauí</option>
            <option value="17">Paraná</option>
            <option value="18">Rio de Janeiro</option>
            <option value="19">Rio Grande do Norte</option>
            <option value="20">Rondônia</option>
            <option value="21">Roraima</option>
            <option value="22">Rio Grande do Sul</option>
            <option value="23">Santa Catarina</option>
            <option value="24">Sergipe</option>
            <option value="25">São Paulo</option>
            <option value="26">Tocantins</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label>Telefone</label>
          <input type="text" class="form-control" v-mask="{mask:['(99)9999-9999','(99)99999-9999']}"  placeholder="Opcional" v-model="fornecedor.telefone">
        </div>
        <div class="form-group col-md-4">
          <label>Email</label>
          <input type="text" class="form-control"  placeholder="Opcional" v-model="fornecedor.email">
        </div>
        <div class="form-group col-md-12">
          <label for="obs">Observações</label>
          <textarea id="obs" class="form-control"  v-model="fornecedor.info_adicionais"></textarea>
        </div>
        <div class="col-md-12">
           <button class="btn btn-info mr-10">{{ fornecedor.codigo ? 'Salvar': 'Cadastrar'}}</button>
        </div>
      </div>
        </form>

      </div>
      <div v-show="!cadastro" class="card-body">
        <h4 class="card-title">Fornecedores</h4>
        <button class="btn btn-info" @click="exibirCadastro" v-if="cadastroWeb">Novo Fornecedor</button>
        <div class="row pt-10">
          <div class="form-group col-md-12 hidden-mobile">
            <table id="listaformaspagamentos" class="display responsive nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
              <thead>
                <tr>
                  <th>Fornecedor</th>
                  <th>CNPJ</th>
                  <th data-hide="phone">Ações</th>
                </tr> 
              </thead>
              <tbody>
                <tr v-for="(item, index) in fornecedores" :key="index">
                  <td>{{ item.razao_nome }}</td>
                  <td>{{ item.cnpj_cpf }}</td>
                  <td v-if="cadastroWeb">
                    <button class="btn btn-sm btn-info px-2 py-1" @click="abrirFornecedor(item)"><i class="fa fa-pencil"></i></button>
                  </td>
                </tr>
                </tbody>
            </table>
          </div>
          
          <div class="mb-6" style="padding-left: 30px">
            <div v-for="(item, index) in fornecedores" :key="index" class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-6">
                <strong>{{ item.razao_nome }}</strong>
                <br>
                CNPJ:{{ item.cnpj_cpf}}
              </div>
              <div class="col-6" align="right">
                <button class="btn btn-sm btn-info px-2 py-1" @click="abrirFornecedor(item)" align="right" style="font-size: 10px;"><i class="fa fa-pencil"></i></button>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
    AnimatedNumber,
  } from 'src/components'
import { setInterval } from 'timers';
import {Table, TableColumn} from 'element-ui'
import moment from 'moment'
import GlobalFunctions from '../../../globalFunctions.js'
import FornecedorService from '../../../services/FornecedorService.js'
import ErrorService from '@/services/ErrorService.js'

import { log } from 'util';
export default {
    components: {
      Card,
      AnimatedNumber,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      moment
    },
    data() {
      return {
        dataInicio: moment().format("YYYY-MM-DD"),
        dataFim: moment().format("YYYY-MM-DD"),
        dataFinalCabecalho:moment().format("DD/MM/YYYY"),
        dataInicioCabecalho:moment().format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(), 
        cadastro: false,
        fornecedores: [],
        estados:["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RO", "RS", "RR", "SC", "SE", "SP", "TO"],
        fornecedor: ({"tipo_nfce":1}),
        loading: false,
        cadastroWeb: localStorage.getItem('config_modulo_cadastro_web') == "true" ? true : false,
      }
    },
    methods:{
      load(){
        FornecedorService.load().then(res=>{
          this.fornecedores = res.data;
        })
      },
      update(){ 
        console.log(this.fornecedor);
        if(this.fornecedor.codigo){
          FornecedorService.update(this.fornecedor).then(res=>{
           this.load()
           this.cadastro = false;  
           this.$swal('Fornecedor atualizada com sucesso!','', 'success')
          })
          .catch(e => {
            ErrorService.getMessage(e.response)
            // this.$swal('Erro ao cadastrar', e,'error')
          })
        }else{
          FornecedorService.create(this.fornecedor).then(res => {
            this.load()
            this.cadastro = false;
            this.$swal('Fornecedor cadastrada com sucesso!','', 'success')
          })
          .catch(e => {
            ErrorService.getMessage(e.response)
            // this.$swal('Erro ao cadastrar', e,'error')
          })
        }
      },
      excluirCadastro(item){
        FornecedorService.destroy(item.codigo).then(res => {
          this.$swal('Fornecedor desativada com sucesso!','', 'success')
          this.load()
          this.cadastro = false;
        })
        .catch(e => {
          ErrorService.getMessage(e.response)
        })
      },
      carregarcep(){
        this.fornecedor.cep = this.fornecedor.cep.replace('-','');
        if(this.fornecedor.cep.length == 8){
          FornecedorService.carregarCep(this.fornecedor.cep)
          .then(result => {
            this.fornecedor.bairro = result.data.bairro;
            this.fornecedor.endereco = result.data.logradouro;
            this.fornecedor.cidade = result.data.localidade;
            this.fornecedor.codigo_cidade = result.data.ibge;
            this.fornecedor.estado = this.estados.indexOf(result.data.uf);
          }).catch(err => {
            console.log(err);
          });
        }
      },
      abrirFornecedor(item){
        this.fornecedor = item;
        this.cadastro = true;
      },
      exibirLista(){
        this.load()
        this.cadastro = false;
      },
      exibirCadastro(){
        this.fornecedor = ({});
        this.cadastro = true;
      }
    },
    mounted(){
      this.load()
    }
}
</script>